import { useEffect } from "react";
import Navigation from "./components/Navigation";
import Hero from "./sections/Hero";
import Stats from "./sections/Stats";
import Benefits from "./sections/Benefits";
import Features from "./sections/Features";
import Pricing from "./sections/Pricing";
import Testimonials from "./sections/Testimonials";
import FAQ from "./sections/FAQ";
import CTA from "./sections/CTA";
import Footer from "./components/Footer";
import { SpeedInsights } from "@vercel/speed-insights/react";

// Google Analytics gtag configuration
declare global {
  interface Window {
    gtag: (command: string, targetId: string, config?: any) => void;
  }
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'GTM-MX53QCJ4', {
        page_title: 'Sera - Your Notification Assistant',
        page_location: window.location.href,
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Navigation />
      <Hero />
      <Stats />
      <Benefits />
      <Features />
      <Pricing />
      <Testimonials />
      <FAQ />
      <CTA />
      <Footer />
      <SpeedInsights />
    </div>
  );
}

export default App;
